










import { Vue, Component } from 'vue-property-decorator';
import ReporteTelemetria from './ReporteTelemetria.vue';

@Component({
  components: { ReporteTelemetria },
})
export default class ReportePantalla extends Vue {}
